import React, { FC } from 'react';
import { FormSelect } from '@atlas-frontend/sdk';
import { useCategoryRelationOptions } from './useCategoryRelationOptions';

interface CategoryRelationSelectProps {
  name: string;
  isCombinedGroups: boolean;
}

export const CategoryRelationSelect: FC<CategoryRelationSelectProps> = (
  props
) => {
  const { isCombinedGroups, name } = props;
  const options = useCategoryRelationOptions(isCombinedGroups);

  return (
    <FormSelect
      name={name}
      autoFocus
      defaultOpen
      showSearch
      allowClear={true}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? '')
          .toString()
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      options={options}
    />
  );
};
